<template>
    <div class="header">
      <nav class="navbar navbar-default navbar-fixed-top" role="navigation">
          <!-- 移动尺寸菜单按钮图标 -->
          <div class="navbar-header">
            <button @click="changeOpenNavValue" type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1" aria-expanded="false">
              <span class="sr-only">Toggle navigation</span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
              <span class="icon-bar"></span>
            </button>
            <router-link class="navbar-brand" :to="{name: 'index'}" alt="首页">
              <img src="../assets/image/comment/logo.png" alt="科创">
            </router-link>
          </div>
          <!-- 响应式菜单 -->
        <el-collapse-transition>
            <div class=" navbar-collapse" v-show="openNav"  id="bs-example-navbar-collapse-1">
              <div class="fr-button navbar-right">
                <a class="btn btn-default design" target="_blank" href="http://app.kcsoft.com.cn/" role="button">3D设计</a>
                <a class="btn btn-default shop" target="_blank" href="https://liangfangshenqi.tmall.com/" role="button">在线商城</a>
                <a class="btn btn-default back-stage" target="_blank" href="http://app.kcsoft.com.cn/CompanyServer/Home/index" role="button">企业后台管理</a>
                <a class="btn btn-default back-stage" target="_blank" href="http://ms.kcsoft.com.cn/" role="button">量房管理系统</a>
              </div>

              <ul class="nav navbar-nav navbar-right">
                <li><router-link :to="{name: 'index'}">首 页</router-link></li>
                <li>
                  <router-link :to="{name: 'produts'}">产品中心</router-link>
                </li>
                <li>
                  <router-link :to="{name: 'downloads'}">下载试用</router-link>
                </li>
                <li>
                  <router-link :to="{name: 'cooperation'}">商务合作</router-link>
                </li>
                <li>
                  <router-link :to="{name: 'aboutUs'}">关于我们</router-link>
                </li>
              </ul>
            </div>
        </el-collapse-transition>
      </nav>
    </div>
</template>

<script>
  export default {
    name: 'websiteHeader',
    // beforeRouteLeave(to, from, next) {
    //   console.log(' beforeRouteLeave !', this)
    //   const answer = window.confirm('确认离开？')
    //   answer ? next() : next(false)
    // },
    // beforeRouteEnter(to, from, next) {
    //   console.log(' beforeRouteEnter !')
    //   next()
    // },
    // // beforeRouteLeave (to, from, next) {
    // //   console.log('sss55')
    // //   var sWidth = window.screenWidth = window.innerWidth || document.body.clientWidth || document.documentElement.clientWidth
    // //   if(sWidth < 768) {
    // //     next(vm => {
    // //       console.log('sss')
    // //       vm.openNav = false
    // //     })
    // //   }else {
    // //     next()
    // //   }
    // // },
    data: function () {
      return {
        openNav: true,
        // closeNav: false,
        screenWidth: window.innerWidth || document.body.clientWidth || document.documentElement.clientWidth
      }
    },
    created: function () {
      var webWidth = window.innerWidth || document.body.clientWidth || document.documentElement.clientWidth
      if(webWidth < 768) {
        this.openNav = false
      }
    },
    mounted: function () {
      const that = this
      window.addEventListener('resize', () => {
        return (() => {
          window.screenWidth = window.innerWidth || document.body.clientWidth || document.documentElement.clientWidth
          that.screenWidth = window.screenWidth
        })()
      })
    },
    watch: {
      //监听屏幕变化
      screenWidth: function (val) {
        if (!this.timer) {
          this.screenWidth = val
          this.timer = true
          let that = this
          setTimeout(function () {
            that.changeScreen(val)
            that.timer = false
          }, 300)
        }
      },
      $route: function (to, from) {
        var sWidth = window.screenWidth = window.innerWidth || document.body.clientWidth || document.documentElement.clientWidth
        if(sWidth < 768) {
          this.openNav = false
        }
      }
    },
    methods: {
      changeOpenNavValue: function () {
        this.openNav = !this.openNav
      },
      changeScreen: function (val) {
        if(this.screenWidth >= 768) {
          this.openNav = true
        } else if (this.screenWidth < 768 && this.openNav === true) {
          this.openNav = false
        }
      }
    }
  }

</script>

<style scoped>
  @media (max-width: 510px){
    .header .container{
      width: 100%;
      padding-right: 0px;
      padding-left: 0px;
    }
  }
  @media (min-width: 510px){
    .header .container{
      width: 100%;
    }
  }

  @media (min-width: 992px){
    .header .container {
      width: 970px;
    }
  }

  @media (min-width: 1200px){
    .header .container {
      width: 1170px;
    }
  }
  .header .navbar {
    margin-bottom: 0px;
    border-bottom: 3px solid #e0e0e0;;
  }
  .header .navbar-default{
    background-color: rgba(255,255,255,0.90);
  }
  .header .navbar-fixed-top{
    position: fixed;
    right: 0;
    left: 0;
    z-index: 1030;
  }
  .header .container>.navbar-header {
    margin-right: 0px;
    margin-left: 0px;
  }
  .header nav .navbar-header .navbar-brand{
    height: inherit;
  }
  .header nav .navbar-header .navbar-toggle{
    position: relative;
    float: right;
    margin-right: 15px;
    background-color: transparent;
    background-image: none;
    border: 1px solid transparent;
    border-radius: 4px;
    margin-top: 25px;
    margin-bottom: 25px;
    border-color: #ddd;

  }
  .header nav .navbar-header .navbar-toggle .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
    background-color: #888;
  }
  .header nav .navbar-header .navbar-toggle .icon-bar{
    background-color: #888;
    display: block;
    width: 22px;
    height: 2px;
    border-radius: 1px;
    margin-top: 4px;
  }
  .header .navbar {
    margin-bottom: 0px;
    border-bottom: 3px solid #e0e0e0;;
  }
  .header .navbar-default{
    background-color: #fff;
  }
  .header .container>.navbar-header {
    margin-right: 0px;
    margin-left: 0px;
  }
  .header nav .navbar-header .navbar-brand{
    height: inherit;
  }
  .header nav .navbar-header .navbar-toggle{
    margin-top: 25px;
    margin-bottom: 25px;
  }
  @media (max-width: 767px){
    .header nav .navbar-header .navbar-toggle {
      margin-top: 15px;
      margin-bottom: 14px;
    }
    .navbar-toggle {
      padding: 7px 8px;
    }
  }
  @media (min-width: 768px) {
    .header nav .navbar-header .navbar-toggle  {
      display: none;
    }
  }

  /*菜单*/

  .header nav .navbar-collapse.in {
    /*overflow-y: hidden;*/
  }
  @media (max-width: 767px){
    .navbar-header{
      z-index: 99;
      position: relative;
      background: #ffffff;

    }
    .header nav .navbar-collapse{
      z-index: 98;

    }
  }
  .header nav .navbar-nav{
    padding-top: 3px;
    /*margin: 7.5px -15px;*/
  }
  .header nav .navbar-nav>li>a{
    font-size: 16px;
    text-align: center;
    color: #777;
    position: relative;
    display: block;
    padding: 10px 15px;
  }
  @media (max-width: 938px){
    .header nav .navbar-nav li a.partition{
      display: none;
      border-bottom: 0px;
    }
  }
  @media (min-width: 768px){
    .navbar-nav > li > a{
      padding-top: 8px;
      padding-bottom: 8px;
    }
  }

  @media (min-width: 768px){
    .header nav .navbar-nav>li>a{
      line-height: 40px;
      padding-top: 11px;
      padding-bottom: 15px;
      padding-left: 5px;
      padding-right: 8px;
      font-size: 14px;
      border-bottom: 1px solid #E0E0E0;
      font-weight: 400;
    }
    .header .navbar-default .navbar-nav>li>a.router-link-active,
    .header .navbar-default .navbar-nav>li>a:hover {
      color: #ffa034;
      border-bottom: 2px solid #ffa034;
    }
    .header nav .navbar-nav li a.partition{
      margin-top: 25px;
      margin-bottom: 20px;
      border-right: 1px solid #ccc;
    border-bottom: 0px;
      margin-right: 10px;
    }
    .header nav .navbar-nav>li>a.partition:hover{
      border-bottom: 2px solid #fff;
      cursor: default;
    }
  }
  @media (min-width: 840px){
    .header nav .navbar-nav li a{
      padding-left: 10px;
      padding-right: 10px;
      font-size: 16px;
      line-height: 50px;
    }
  }
  @media (min-width: 930px){
    .header nav .navbar-nav>li>a {
      line-height: 50px;
      padding-top: 15px;
      padding-bottom: 16px;
    }
    .header nav .navbar-nav li a .partition{
      border-right: 1px solid #ccc;
    }
  }
  /*在线商城  3D设计 后台管理*/
  .header .fr-button{
    text-align: center;
    margin-bottom: 20px;
  }
  @media (max-width: 767px){
    .header nav .navbar-collapse.in{
      position: absolute;
    }
    .header .fr-button{
      margin-bottom: 20px;
      position: absolute;
      bottom: 0;
      left: 0;
      display: flex;
      justify-content: center;
      width: 100%;
      flex-wrap: wrap;
    }
    .header nav .navbar-nav{
      padding-bottom: 100px;
    }
  }
  .header .fr-button .btn-default{
    color: #fff;
  }
  .header .fr-button .btn-default:hover{
    color: #fcfcfc;
  }
  .header .fr-button .shop,
  .header .fr-button .back-stage{
    background-color: #00a0e9;
    border-color: #00a0e9;
  }
  .header .fr-button .shop:hover,
  .header .fr-button .back-stage:hover{
    background-color: #2db7f5;
    border-color: #2db7f5;
  }
  /*.header .fr-button>div{*/
  /*  display: inline-block;*/
  /*}*/
  .header .fr-button .design{
    margin-left: 10px;
    background-color: #FCA134;
    border-color: #FCA134;
  }
  .header .fr-button .design:hover{
    background-color: #FDAC23;
    border-color: #FDAC23;
  }
  @media (max-width: 767px){
    /*.header .fr-button>div{*/
    /*  display: block;*/
    /*  margin: auto;*/
    /*}*/
  }
  @media (min-width: 768px){
    .header .fr-button{
      margin-right: 10px;
      height: inherit;
      margin-bottom: 0px;
    }
    .header .fr-button{
      line-height: 64px;
    }
    .header .fr-button .shop,
    .header .fr-button .back-stage{
      margin-left: 0px;
    }
    .header .fr-button .btn{
      padding: 6px 8px;
    }
  }
  @media (min-width: 840px){
    .header .fr-button .shop,
    .header .fr-button .back-stage{
      margin-left: 5px;
    }
    .header .fr-button{
      line-height: 76px;
    }
  }
  @media (min-width: 930px){
    .header .fr-button{
      margin-left: 15px;
      line-height: 84px;
    }
    .header .fr-button .shop,
    .header .fr-button .back-stage{
      margin-left: 15px;
    }
    .header .fr-button .btn{
      padding: 6px 15px;
    }
  }
  @media (min-width: 1200px){
    .header .fr-button{
      margin-left: 30px;
    }
  }
  @media (max-width: 767px){
    .header .fr-button .btn{
      padding-left: 10px;
      padding-right: 10px;
      margin-left: 8px;
      margin-top: 10px;
    }
    .header .fr-button .shop,
    .header .fr-button .back-stage{
      margin-left: 8px;
    }
  }
  /*header logo*/
  @media (min-width: 768px){
    .header .navbar-brand>img{
      width: 100px;
    }
    .header .navbar-brand{
      padding: 15px 15px;
    }
  }
  @media (min-width: 840px){
    .header .navbar-brand>img{
      width: 120px;
    }
  }
  @media (min-width: 930px){
    .header .navbar-brand>img{
      width: 138px;
    }
  }
  @media (max-width: 767px){
    .header .navbar-brand>img{
      width: 100px;
    }
    .navbar-brand {
      padding: 10px 15px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/websiteHeader.vue